import type React from "react";

interface ChevronProps {
  className?: string;
  orientation: "down" | "up" | "left" | "right";
}

const rotations = {
  down: 0,
  up: 180,
  left: 90,
  right: -90,
} as const;

export function ChevronIcon({ className, orientation }: ChevronProps): React.ReactNode {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        className="origin-center transition-transform"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 9l-7 7-7-7"
        transform={`rotate(${rotations[orientation]})`}
      />
    </svg>
  );
}
